import React from 'react'
import Manager from '../../public/components/Manager'
import AddMonthlySalaryApplyDiv from './AddMonthlySalaryApplyDiv'
import MonthlySalaryApplyDetail from './MonthlySalaryApplyDetail'
import MonthlySalaryDeductionDetail from './MonthlySalaryDeductionDetail'
Ext.require('Ext.Toast')

const config = {
    tabs:
    {
        制作中: {
            buttons: [
                {
                    text: '添加...', handler: ({ showDetail, refreshPage }) =>
                        Tyan.pubForm.showDialog('月薪申请', props => <AddMonthlySalaryApplyDiv {...props} id={0} onSave={refreshPage} />)
                },
            ],
            columns: [
                { _text: '发放月份', field: 'Issue', minWidth: 110, search: true, },
                //{ _date: '薪资所得给付日', field: 'SalaryPaymentDate', minWidth: 150, filter: true, align: 'right'},
                { _float: '应发总额', minWidth: 110, flex: 10, filter: true },
                { _float: '实发总额', minWidth: 110, flex: 10, filter: true },
                // { _float: '住房公积金', minWidth: 150, filter: true, },
                // { _float: '社保个人扣款', minWidth: 150, filter: true, },
                { _float: '应税加班', field: '_TaxableWorkOvertime', minWidth: 110, flex: 10, filter: true },
                { _float: '生日礼金', field: '_BirthdayGift', minWidth: 110, flex: 10, filter: true },
                { _float: '餐费补助', field: '_MealAllowance', minWidth: 110, flex: 10, filter: true },
                { _float: '高温补贴', field: '_HighTemperatureAllowance', minWidth: 110, flex: 10, filter: true },
                { _float: '季度奖金', field: '_QuarterlyBonus', minWidth: 110, flex: 10, filter: true },
                { _float: '其他税前(+)', field: '_OtherPreTaxItems', minWidth: 120, flex: 10, filter: true },
                { _float: '其他税前(-)', field: '_OtherPreTaxDeductions', minWidth: 120, flex: 10, filter: true },
                { _float: '请假扣款', field: '_AskForLeaveDeductions', minWidth: 110, flex: 10, filter: true },
                // { _float: '应发工资', field: '_ShouldPay', minWidth: 150, flex: 10, filter: true},
                // { _float: '所得税', field: '_IncomeTax', minWidth: 150, flex: 10, filter: true},
                { _float: '所得税', minWidth: 100, filter: true, },
                { _float: '代扣话费', field: '_WithholdingMoney', minWidth: 110, flex: 10, filter: true },
                { _float: '代扣班车费', field: '_BusFaresAreDeducted', minWidth: 120, flex: 10, filter: true },
                { _float: '代扣餐费', field: '_WithholdingMeals', minWidth: 110, flex: 10, filter: true },
                { _float: '其他税后(-)', field: '_OtherAfterTaxDeductions', minWidth: 120, flex: 10, filter: true },
                { _float: '其他税后(+)', field: '_OtherAfterTaxItems', minWidth: 120, flex: 10, filter: true },
                { _float: '住房津贴', field: '_HousingAllowance', minWidth: 110, flex: 10, filter: true },
                // { _float: '实发工资', field: '_RealWages', minWidth: 150, flex: 10, filter: true},
                { _int: '人数', minWidth: 70, filter: true, },
                { _: 'taskName', field: '_TaskName' },
                {
                    _button: '编辑...', locked: 'right', icon: 'edit', minWidth: 120, handler: ({ showDetail, refreshPage }, data) => {
                        showDetail(props => <MonthlySalaryDeductionDetail {...props} id={data.id} taskName={data.taskName} />)
                    }
                },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <MonthlySalaryApplyDetail {...props} id={data.id} />)
            }
        },
        已完成: {
            buttons: [
            ],
            columns: [
                { _text: '发放月份', field: 'Issue', minWidth: 110, search: true, },
                //{ _date: '薪资所得给付日', field: 'SalaryPaymentDate', minWidth: 150, filter: true, align: 'right'},
                { _float: '应发总额', minWidth: 110, flex: 10, filter: true },
                { _float: '实发总额', minWidth: 110, flex: 10, filter: true },
                // { _float: '住房公积金', minWidth: 150, filter: true, },
                // { _float: '社保个人扣款', minWidth: 150, filter: true, },
                { _float: '应税加班', field: '_TaxableWorkOvertime', minWidth: 110, flex: 10, filter: true },
                { _float: '生日礼金', field: '_BirthdayGift', minWidth: 110, flex: 10, filter: true },
                { _float: '餐费补助', field: '_MealAllowance', minWidth: 110, flex: 10, filter: true },
                { _float: '高温补贴', field: '_HighTemperatureAllowance', minWidth: 110, flex: 10, filter: true },
                { _float: '季度奖金', field: '_QuarterlyBonus', minWidth: 110, flex: 10, filter: true },
                { _float: '其他税前(+)', field: '_OtherPreTaxItems', minWidth: 120, flex: 10, filter: true },
                { _float: '其他税前(-)', field: '_OtherPreTaxDeductions', minWidth: 120, flex: 10, filter: true },
                { _float: '请假扣款', field: '_AskForLeaveDeductions', minWidth: 110, flex: 10, filter: true },
                // { _float: '应发工资', field: '_ShouldPay', minWidth: 150, flex: 10, filter: true},
                // { _float: '所得税', field: '_IncomeTax', minWidth: 150, flex: 10, filter: true},
                { _float: '所得税', minWidth: 100, filter: true, },
                { _float: '代扣话费', field: '_WithholdingMoney', minWidth: 110, flex: 10, filter: true },
                { _float: '代扣班车费', field: '_BusFaresAreDeducted', minWidth: 120, flex: 10, filter: true },
                { _float: '代扣餐费', field: '_WithholdingMeals', minWidth: 110, flex: 10, filter: true },
                { _float: '其他税后(-)', field: '_OtherAfterTaxDeductions', minWidth: 120, flex: 10, filter: true },
                { _float: '其他税后(+)', field: '_OtherAfterTaxItems', minWidth: 120, flex: 10, filter: true },
                { _float: '住房津贴', field: '_HousingAllowance', minWidth: 110, flex: 10, filter: true },
                // { _float: '实发工资', field: '_RealWages', minWidth: 150, flex: 10, filter: true},
                // { _float: '所得税', minWidth: 150, filter: true, },
                { _int: '人数', minWidth: 70, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <MonthlySalaryApplyDetail {...props} id={data.id} />)
            }
        }
    }
}

export default props => <Manager {...props} config={config} />